import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=40a7093a&scoped=true"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=40a7093a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7093a",
  null
  
)

export default component.exports